module.exports = __webpack_public_path__ + "media/fonts/Oricons-96aa82557dbb0d6b8c50ebd788d35cae.svg";